import { FileInput, Form } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import useArtwork from '@hooks/useArtwork'

import { OrderItemModel, OrderModel } from '@models/types'

type UploadArtworkParams = {
  fileData: object,
  order: OrderModel,
  order_item: OrderItemModel,
  uploadArtworkFn: Function,
}
const uploadArtwork = (params: UploadArtworkParams) => {
  const {
    fileData, order, order_item, uploadArtworkFn,
  } = params

  if (!fileData) return

  const uploadArtworkPayload = {
    callbacks: {
      action: uploadArtworkFn,
    },
    entityParams: {
      artwork_file: fileData,
      campaign_id: order.campaign_id,
      order_item_id: order_item.id,
    },
    toastText: 'Artwork Uploaded',
  }

  // @ts-expect-error TS2345
  handleCallbackAction(uploadArtworkPayload)
}
interface ArtworkUploaderProps {
  order: OrderModel,
  order_item: OrderItemModel,
}
const ArtworkUploader = (props: ArtworkUploaderProps) => {
  const { order, order_item } = props

  const {
    callbacks: {
      uploadArtwork: uploadArtworkFn,
    },
  } = useArtwork({ id: order_item?.artwork_id })

  return (
    <Form.Field label="Artwork">
      <FileInput
        input={{
          accept: '.pdf',
          onChange: (fileData: {}) => {
            uploadArtwork({
              fileData, order, order_item, uploadArtworkFn,
            })
          },
        }}
      />
    </Form.Field>
  )
}

export default ArtworkUploader
